<div *ngIf="profile">
  <h3 style="text-align: center; margin-top: 12px">
    {{ profile.handle }} &mdash; {{ profile.displayName }}
  </h3>
  <form fxLayout="column" (ngSubmit)="save()">
    <div class="wrapper">
      <div>
        <app-user-detail-destinations-nations
          [nations]="profile.destinations.nations"
        ></app-user-detail-destinations-nations>
      </div>
    </div>

    <p style="text-align: center">
      <button mat-raised-button color="primary" type="submit">Salva</button>
    </p>
  </form>
</div>
